import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import { useRouteQuery } from '../../hooks/useRouteQuery';

function PublicRoute({ component: Component, ...rest }) {
  const { user } = useSelector((state) => {
    const { signInReducer } = state;
    return {
      user: signInReducer.user,
    };
  });

  const location = useLocation();
  const redirectionPath = location.from ? location.from.pathname : '/';

  return (
    <Route
      {...rest}
      render={(props) => {
        return user ? (
          <Redirect
            to={{
              ...location,
              pathname: redirectionPath,
              from: location,
            }}
          />
        ) : (
          <Component {...props} />
        );
      }}
    />
  );
}

export default PublicRoute;
